import React from "react";
import prop from "ramda/src/prop";
import compose from "ramda/src/compose";
import groupBy from "ramda/src/groupBy";
import Chip from "@mui/material/Chip";
import Box from "@mui/material/Box";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";

import { normalize } from "../../helpers/normalize";
interface IOption {
  name: string;
  id: number;
}

interface IProps {
  label: string;
  value: number[];
  options: IOption[];
  valuesDisabled?: number[];
  handleChange: (e: React.ChangeEvent<{ value: number[] }>) => void;
}

export const ChipMultipleSelect: React.FC<IProps> = (props) => {
  const optionsById = React.useMemo(() => groupBy(compose(String, prop("id")), props.options), [
    normalize(props.options),
  ]);

  return (
    <FormControl variant="filled" fullWidth>
      <InputLabel id={props.label}>{props.label}</InputLabel>
      <Select
        multiple
        fullWidth
        variant="filled"
        value={props.value}
        labelId={props.label}
        onChange={props.handleChange as any}
        renderValue={(selected) => (
          <Box display="flex" flexWrap="wrap">
            {(selected as number[]).map((id) => (
              <Chip key={id} color="primary" sx={{ m: 2 }} label={optionsById[id][0].name} />
            ))}
          </Box>
        )}
      >
        {props.options.map((option) => (
          <MenuItem key={option.id} value={option.id} disabled={props.valuesDisabled?.includes(option.id)}>
            {option.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
